module.exports = __webpack_public_path__ + "static/media/footer-icon-2.59f0ac69.svg";